"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.DatePickerPopover = void 0;
var tslib_1 = require("tslib");
var date_fns_1 = require("date-fns");
var fp_1 = require("lodash/fp");
var react_1 = tslib_1.__importStar(require("react"));
var styled_components_1 = tslib_1.__importDefault(require("styled-components"));
var Buttons_1 = require("../Buttons");
var Calendar_1 = require("../Calendar");
var DatePickerValidationFunctions_1 = require("./DatePickerValidationFunctions");
var RangePicker_1 = require("./RangePicker");
var StyledSmart_1 = require("./StyledSmart");
var smartDate_1 = require("./smartDate");
exports.DatePickerPopover = function (_a) {
    var datePickerType = _a.datePickerType, smartDateType = _a.smartDateType, startDate = _a.startDate, endDate = _a.endDate, _b = _a.selectRange, selectRange = _b === void 0 ? false : _b, _c = _a.confirmText, confirmText = _c === void 0 ? 'Apply' : _c, _d = _a.cancelText, cancelText = _d === void 0 ? 'Cancel' : _d, smartDateWhitelist = _a.smartDateWhitelist, setStartDate = _a.setStartDate, setEndDate = _a.setEndDate, setSmartDateType = _a.setSmartDateType, _e = _a.onConfirm, onConfirm = _e === void 0 ? fp_1.noop : _e, onClose = _a.onClose, maxDate = _a.maxDate, minDate = _a.minDate, calendarType = _a.calendarType, autoFocusEndDate = _a.autoFocusEndDate, _f = _a.isRange, isRange = _f === void 0 ? true : _f, tileDisabled = _a.tileDisabled;
    var _g = react_1.useState(false), hasDateChangeOccurred = _g[0], setHasDateChangeOccurred = _g[1];
    var _h = react_1.useState(startDate), internalStartDate = _h[0], setInternalStartDate = _h[1];
    var _j = react_1.useState(endDate), internalEndDate = _j[0], setInternalEndDate = _j[1];
    var _k = react_1.useState(smartDateType), internalSmartDate = _k[0], setInternalSmartDate = _k[1];
    var handleInternalStartDateChange = function (newDate) {
        setInternalStartDate(newDate);
    };
    var handleInternalEndDateChange = function (newDate) {
        setInternalEndDate(newDate);
    };
    var onStartDateChange = function (newDate) {
        setHasDateChangeOccurred(true);
        if (date_fns_1.isValid(newDate)) {
            setInternalStartDate(newDate);
            setInternalSmartDate(undefined);
        }
    };
    var onEndDateChange = function (newDate) {
        setHasDateChangeOccurred(true);
        if (date_fns_1.isValid(newDate)) {
            setInternalEndDate(newDate);
            setInternalSmartDate(undefined);
        }
    };
    var onSmartDateChange = function (optionalSmartDate) {
        setHasDateChangeOccurred(true);
        setInternalSmartDate(optionalSmartDate);
    };
    var onCancel = function () {
        setInternalStartDate(startDate);
        setInternalEndDate(endDate);
        setInternalSmartDate(smartDateType);
        onClose();
    };
    var onApply = function () {
        setStartDate(internalStartDate);
        setEndDate(internalEndDate);
        setSmartDateType(internalSmartDate);
        onConfirm(internalStartDate, internalEndDate, internalSmartDate);
        onClose();
    };
    var isValidStartDate = DatePickerValidationFunctions_1.validateStartDate(datePickerType, internalSmartDate, internalStartDate, internalEndDate, maxDate, minDate);
    var isValidEndDate = DatePickerValidationFunctions_1.validateEndDate(datePickerType, internalSmartDate, internalStartDate, internalEndDate, maxDate, minDate);
    var isRangePickerInvalid = !(isValidStartDate && isValidEndDate) || !hasDateChangeOccurred;
    var isSingleDatePickerInvalid = !hasDateChangeOccurred || !isValidStartDate;
    var isApplyDisabled = isRange
        ? isRangePickerInvalid
        : isSingleDatePickerInvalid;
    var disableTiles = datePickerType !== smartDate_1.DatePickerTypeOptions.dateRange &&
        datePickerType !== smartDate_1.DatePickerTypeOptions.singleSmartDates &&
        datePickerType !== smartDate_1.DatePickerTypeOptions.lastOfMonth &&
        datePickerType !== smartDate_1.DatePickerTypeOptions.portfolioPlanningSmartDates &&
        datePickerType !== smartDate_1.DatePickerTypeOptions.simpleDateRange;
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(StyledSmart_1.StyledSplitPaneContainer, null,
            react_1.default.createElement(StyledSmart_1.StyledLeftPane, null,
                react_1.default.createElement(Calendar_1.CalendarBase, { startDate: internalStartDate, undefinedStartDateText: "Inception", endDate: internalEndDate, isRange: isRange, calendarType: calendarType, selectRange: selectRange, disableTiles: disableTiles, disableTilesOnStart: disableTiles ? Calendar_1.disableTilesOnStart : undefined, disableTilesOnEnd: disableTiles ? Calendar_1.disableTilesOnEnd : undefined, tileDisabled: tileDisabled, onStartDateChange: onStartDateChange, onEndDateChange: onEndDateChange, isValidStartDate: isValidStartDate, isValidEndDate: isValidEndDate, maxDate: maxDate, minDate: minDate, autoFocusEndDate: autoFocusEndDate, datePickerType: datePickerType, allowsUndefinedDate: true })),
            react_1.default.createElement(StyledSmart_1.StyledRightPane, null,
                react_1.default.createElement(RangePicker_1.RangePicker, { setStartDate: handleInternalStartDateChange, setEndDate: handleInternalEndDateChange, datePickerType: datePickerType, smartDateType: internalSmartDate, whitelist: smartDateWhitelist, setSmartDateType: onSmartDateChange }))),
        react_1.default.createElement(StyledButtonContainer, null,
            react_1.default.createElement(Buttons_1.ButtonGroup, null,
                react_1.default.createElement(Buttons_1.Button, { "data-testid": "datepicker-cancel-button", buttonStyle: "SECONDARY", onClick: onCancel }, cancelText),
                react_1.default.createElement(StyledApplyButton, { "data-testid": "datepicker-apply-button", buttonStyle: "PRIMARY", onClick: onApply, disabled: isApplyDisabled }, confirmText)))));
};
var StyledButtonContainer = styled_components_1.default.div(templateObject_1 || (templateObject_1 = tslib_1.__makeTemplateObject(["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  text-align: right;\n  padding: 1.6rem;\n  border-top: ", ";\n  background-color: ", ";\n  height: 6.4rem;\n"], ["\n  display: flex;\n  flex-direction: row;\n  justify-content: flex-end;\n  width: 100%;\n  text-align: right;\n  padding: 1.6rem;\n  border-top: ", ";\n  background-color: ", ";\n  height: 6.4rem;\n"])), function (_a) {
    var theme = _a.theme;
    return "1px solid " + theme.colors.NTDarkGrey[200];
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.NTDarkGrey[0];
});
var StyledApplyButton = styled_components_1.default(Buttons_1.Button)(templateObject_2 || (templateObject_2 = tslib_1.__makeTemplateObject(["\n  && {\n    background-color: ", ";\n    border: 1px solid ", ";\n\n    :hover,\n    :active,\n    :focus-visible {\n      background-color: ", ";\n    }\n\n    :focus-visible {\n      outline: 1px solid ", ";\n    }\n  }\n"], ["\n  && {\n    background-color: ", ";\n    border: 1px solid ", ";\n\n    :hover,\n    :active,\n    :focus-visible {\n      background-color: ", ";\n    }\n\n    :focus-visible {\n      outline: 1px solid ", ";\n    }\n  }\n"])), function (_a) {
    var theme = _a.theme;
    return theme.colors.datePicker.apply;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.datePicker.apply;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.datePicker.applyDark;
}, function (_a) {
    var theme = _a.theme;
    return theme.colors.datePicker.applyOutline;
});
var templateObject_1, templateObject_2;
